<template>
	<div>
		<div class="search-box">
			<b-form @submit.prevent="list">
				<b-row>
					<b-col cols="12" sm="6">
						<b-form-group id="destinationNameFormGroup" :label="translation.destination">
							<multiselect v-model="hotelsFilterClient.destination" :options="groupedDestinationsResult"
								group-values="destinations" group-label="type" @search-change="searchDestinations" track-by="id"
								label="name">
								<span slot="noResult">{{ translation.destinationNotFound }}</span>
							</multiselect>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row class="mb-3">
					<b-col cols="6" sm="3">
						<b-form-group id="checkinFormGroup" :label="translation.checkin">
							<b-form-datepicker v-model="hotelsFilterClient.checkin" :min="new Date()" :hide-header="true"
								:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" placeholder=""
								:required="true" :label-help="null"></b-form-datepicker>
						</b-form-group>
					</b-col>
					<b-col cols="6" sm="3">
						<b-form-group id="checkoutFormGroup" :label="translation.checkout">
							<b-form-datepicker v-model="hotelsFilterClient.checkout" :min="hotelsFilterClient.checkin" :hide-header="true"
								:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" placeholder=""
								:required="true"  :label-help="null"></b-form-datepicker>
						</b-form-group>
					</b-col>
					<b-col cols="4" sm="1">
						<b-form-group id="roomsFormGroup" :label="translation.rooms">
							<b-form-select v-model="hotelsFilter.roomsQty" :options="Array.from({ length: 5 }, (_, i) => i + 1)"
								required></b-form-select>
						</b-form-group>
					</b-col>
					<b-col cols="4" sm="1">
						<b-form-group id="adultsFormGroup" :label="translation.adults">
							<b-form-select v-model="hotelsFilter.adultsQty" :options="Array.from({ length: 4 }, (_, i) => i + 1)"
								required></b-form-select>
						</b-form-group>
					</b-col>
					<b-col cols="4" sm="1">
						<b-form-group id="childrenFormGroup" :label="translation.children">
							<b-form-select :value="hotelsFilter.chdNumber" @change="childrenChange($event)"
								:options="Array.from({ length: 3 }, (_, i) => i)"></b-form-select>
						</b-form-group>
					</b-col>
					<b-col cols="4" sm="1" v-for="(age, index) in hotelsFilter.chdAges" :key="index">
						<b-form-group id="chdAgesFormGroup" :label="translation.age">
							<b-form-select v-model="hotelsFilter.chdAges[index]"
								:options="Array.from({ length: 12 }, (_, i) => i)"></b-form-select>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-button class="search-button" type="submit">{{ translation.search }}</b-button>
					</b-col>
				</b-row>
			</b-form>
		</div>
		<div class="order-box" v-if="hotels != null && !loading">
			<div class="title">
				<span>{{ translation.sortBy }}:</span>
				<div class="arrow"></div>
			</div>
			<div class="options">
				<span @click="hotelsFilterClient.orderBy = {...hotelsFilterClient.orderBy, field: 'starRating'}">
					<span>{{ translation.starsUpperCase }}</span>
					<span class="material-icons-round"> {{ getIcon('starRating')}}</span>
				</span>
				<span @click="hotelsFilterClient.orderBy = {...hotelsFilterClient.orderBy, field: 'price'}">
					<span>{{ translation.priceUpperCase }}</span>
					<span class="material-icons-round"> {{ getIcon('price')}}</span>
				</span>
				<span @click="hotelsFilterClient.orderBy = {...hotelsFilterClient.orderBy, field: 'name'}">
					<span>{{ translation.hotelNameUpperCase }}</span>
					<span class="material-icons-round"> {{ getIcon('name') }}</span>
				</span>
			</div>
		</div>
		<div class="results-container" v-if="hotels != null && !loading">
			<div class="pagination-box">
				<span style="align-self: center;"> {{ translation.resultsText(hotelsFilterClient.totalItems, Math.ceil(hotelsFilterClient.totalItems/hotelsFilterClient.perPage)) }} </span>
				<b-pagination
    		  v-model="hotelsFilterClient.currentPage"
    		  :total-rows="hotelsFilterClient.totalItems"
    		  :per-page="hotelsFilterClient.perPage"
					@input="filterHotels()"
					pills
					:first-text="translation.pagination.first"
      		:prev-text="translation.pagination.prev"
      		:next-text="translation.pagination.next"
      		:last-text="translation.pagination.last"
    		></b-pagination>
			</div>
			<div class="results-area">
				<aside class="filter-box">
					<p class="filter-title">
						{{ translation.filters }}<span class="material-icons-round mobile-filter-button" @click="mobileFilterOpen = !mobileFilterOpen">{{ mobileFilterOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</span>
					</p>
					<span class="filter-fields" :class="{'open': mobileFilterOpen}">
						<div>
							<b-form-group :label="translation.hotelName">
								<b-form-input @input="filterHotels()" v-model="hotelsFilterClient.name"></b-form-input>
							</b-form-group>
						</div>
						<div>
							<b-form-group :label="translation.stars">
								<b-form-rating stars="5" style="background-color: transparent;" color="#163247" v-model="hotelsFilterClient.starRating" :no-border="true" @change="filterHotels()"></b-form-rating>
							</b-form-group>
						</div>
						<div>
							<b-form-group :label="translation.price">
								<span>{{ userCurrency.symbol }} {{ hotelsFilterClient.min + ',00' }} - {{ hotelsFilterClient.max + ',00' }}</span>
								<DoubleRangeSlider :minThreshold="range.min" :maxThreshold="range.max" :min="hotelsFilterClient.min" :max="hotelsFilterClient.max" ref="doubleRangeSlider"
									@updateMin="(value) => updateRangeValue(Number(value), 'min')"
									@updateMax="(value) => updateRangeValue(Number(value), 'max')">
								</DoubleRangeSlider>
							</b-form-group>
						</div>
						<div>
							<b-form-group :label="translation.district">
								<b-form-checkbox-group
									v-model="hotelsFilterClient.selectedDistrict"
									:options="districts"
									:stacked="smartPhoneBreakpoint ? false : true"
									name="districts-filter"
									@input="filterHotels()"
								></b-form-checkbox-group>
							</b-form-group>
						</div>
						<b-button @click="clearFilter()">
							{{ translation.clearButton }}
						</b-button>
					</span>
				</aside>
				<section class="result-box">
					<div v-for="hotel in hotels" class="hotel-info">
						<div class="hotel-info-header">
							<img :src="hotel.facadeImagePath" :alt="hotel.name" :title="hotel.name" />
						</div>
						<div class="hotel-summary">
							<b>{{ hotel.name }}</b>
							<div>
								<span v-for="star in hotel.starRating" class="material-icons-round rating-star">star_rate</span>
							</div>
							<b-button class="btn-more-about" size="sm" @click="toggleMore(hotel.id)">{{ translation.more }}</b-button>
						</div>
						<div :id="'more-about-'+hotel.id" class="more-about-box" :key="hotel.id">
							<div class="topics">
								<a :href="'#hotel-facilities-' + hotel.id" class="topic">
									<span class="topic-info">{{ translation.hotelFacilities }}</span>
									<span class="material-icons-round" style="float: right;">keyboard_arrow_down</span>
								</a>
								<a :href="'#hotel-location-' + hotel.id" class="topic">
									<span class="topic-info">{{ translation.hotelLocation }}</span>
									<span class="material-icons-round" style="float: right;">keyboard_arrow_down</span>
								</a>
								<a :href="'#rooms-facilities-' + hotel.id" class="topic">
									<span class="topic-info">{{ translation.roomsFacilities }}</span>
									<span class="material-icons-round" style="float: right;">keyboard_arrow_down</span>
								</a>
							</div>
							<div class="hotel-info-area" >
								<b-carousel
    						  id="carousel-no-animation"
    						  style="text-shadow: 0px 0px 2px #000"
									:interval="0"
    						  no-animation
									controls
    						>
    						  <b-carousel-slide v-for="image in hotelInfo.images" :img-src="image.path" :key="image.id"></b-carousel-slide>
    						</b-carousel>
							</div>
							<div class="hotel-description">{{ hotelInfo.description }}</div>
							<div class="hotel-info-area">
								<blumar-map :id="'hotel-location-' + hotel.id" :address="hotel.address ? hotel.address + ' - ' + hotel.district : null" :mapLink="hotel.mapLink" :locationName="hotel.name"></blumar-map>
							</div>
							<div :id="'hotel-facilities-' + hotel.id" class="hotel-info-area" v-if="hotelInfo.facilities">
								<b>{{ translation.hotelFacilities }}</b>
								<br/>
								<span v-for="facility in hotelFacilities" class="facility">
									<i class="material-icons-round" style="font-size: 14px;">done</i>
									<span>{{ facility }}</span>
								</span>
							</div>
							<div :id="'rooms-facilities-' + hotel.id" class="hotel-info-area" v-if="hotelInfo.facilities">
								<b>{{ translation.roomsFacilities }}</b>
								<br/>
								<span v-for="facility in roomFacilities" class="facility">
									<i class="material-icons-round" style="font-size: 14px;">done</i>
									<span>{{ facility }}</span>
								</span>
							</div>
						</div>
						<div class="hotel-info-price">
							<b-row>
								<b-col cols="5" sm="5"></b-col>
								<b-col cols="3" sm="3"></b-col>
								<b-col cols="4" sm="2">rate p/rm/nt</b-col>
								<b-col sm="2"></b-col>
							</b-row>
							<div v-for="(roomType, roomIndex) in hotel.roomTypes" :class="{ 'white-row': roomIndex % 2 == 0 }">
								<b-row v-for="(price, i) in roomType.prices" :set="roomTypeName = roomType.translations.find(t => t.language.id == $store.state.language.id).name" v-b-tooltip.hover :title="showRowTooltip(price.id, roomType.id) ? describeCancelationPolicy(price.cancellationPolicy, $store.state.language) : ''" :key="price.id">
									<b-col cols="5" sm="5" v-b-tooltip.hover.left :title="price.supplierId == BLUMAR_SUPPLIER_ID ? roomTypeName : '-'+roomTypeName">
										<span style="vertical-align: middle;">{{ roomTypeName }}</span>
										<span v-if="price.cancellationPolicy.nonRefundable" class="material-icons-round red" style="vertical-align: middle;">warning</span>
									</b-col>
									<b-col cols="3" sm="3">{{ price.mealPlan ? translation.mealPlans[price.mealPlan.name.replace(' ', '')] : translation.mealPlans.noMeals }}</b-col>
									<b-col cols="4" sm="2">{{ price.priceCurrency.symbol }}{{ price.dailyPricePerRoom }}</b-col>
									<b-col sm="2">
										<b-button class="btn-book" size="sm" @click="openConfirmation(hotel,roomType,price)">{{ translation.book }}</b-button>
									</b-col>
									<booking-confirmation :ref="price.id+'confirmations'+roomType.id" :id="'confirmations'+roomType.id" :userCurrency="userCurrency"></booking-confirmation>
								</b-row>
							</div>
						</div>
					</div>
				</section>
			</div>
			<div class="pagination-box" style="justify-content: end;">
				<b-pagination
    		  v-model="hotelsFilterClient.currentPage"
    		  :total-rows="hotelsFilterClient.totalItems"
    		  :per-page="hotelsFilterClient.perPage"
					@input="filterHotels()"
					pills
					:first-text="translation.pagination.first"
      		:prev-text="translation.pagination.prev"
      		:next-text="translation.pagination.next"
      		:last-text="translation.pagination.last"
    		></b-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import HotelService from '../../services/HotelService'
import DestinationService from '../../services/DestinationService'
import DestinationType from '../../enums/DestinationType'
import { translate } from '../../assets/translations';
import { groupBy, sortBy, maxBy, minBy } from 'lodash';
import moment from 'moment';
import DoubleRangeSlider from './DoubleRangeSlider.vue';
import BlumarMap from '../blumar-map/BlumarMap.vue';
import BookingConfirmation from '../booking-confirmation/BookingConfirmation.vue';
import { describeCancelationPolicy } from '../../cancellation-policy-utils';

export default {
	components: {DoubleRangeSlider, BlumarMap, BookingConfirmation},
	data() {
		return {
			hotelService: new HotelService(JSON.parse(localStorage.getItem('user'))),
			destinationService: new DestinationService(JSON.parse(localStorage.getItem('user'))),
			userCurrency:JSON.parse(localStorage.getItem('user')).currency,
			hotels: null,
			hotelInfo: {},
			destinations: [],
			hotelsFilterClient: {
				destination: '',
				name: '',
				checkin: '',
				checkout: '',
				starRating: 5,
				selectedDistrict: [],
				currentPage: 1,
				perPage: 10,
				totalItems: null,
				orderBy: {
					field: 'starRating',
					desc: true
				},
			},
			hotelsFilter: {
				roomsQty: 1,
				adultsQty: 2,
				chdAges: []
			},
			range: {},
			mobileFilterOpen: false,
			loading: false,
			districts: [],
			BLUMAR_SUPPLIER_ID: 1,
		}
	},
	computed: {
		hotelFacilities() {
			return this.hotelInfo.facilities.filter(f => f.type.name == 'HOTEL')
			.map(f => f.translations.find(t => t.language.id == this.$store.state.language.id).name).sort();
		},
		roomFacilities() {
			return this.hotelInfo.facilities.filter(f => f.type.name == 'ROOM')
			.map(f => f.translations.find(t => t.language.id == this.$store.state.language.id).name).sort();
		},
		translation() {
			return translate(this.$store.state.language).searchArea;
		},
		groupedDestinationsResult() {
			var groupedDestinationsResult = [];
			for (const [key, value] of Object.entries(groupBy(this.destinations, 'type'))) {
				groupedDestinationsResult.push({type: this.translation[DestinationType[key].translationField], destinations: value});
			}
			return groupedDestinationsResult;
		},
		smartPhoneBreakpoint() {
			return window.innerWidth < 576;
		}
	},
	created() {
		if(this.$route.params.widgetHotelsFilter) {
			var widgetsFilter = this.$route.params.widgetHotelsFilter;
			this.hotelsFilterClient = {...this.hotelsFilterClient, destination: widgetsFilter.destination, checkin: widgetsFilter.checkin, checkout: widgetsFilter.checkout}
			this.hotelsFilter = {...this.hotelsFilter, roomsQty: widgetsFilter.roomsQty, adultsQty: widgetsFilter.adultsQty, chdAges: widgetsFilter.chdAges, chdNumber: widgetsFilter.chdNumber};
			this.list();
		}
	},
	methods: {
		describeCancelationPolicy,
		searchDestinations(name) {
			if (name.length >= 3) {
				this.destinationService.getHotelsAndCitiesByName(name)
					.then((res) => this.destinations = res.data.destinations);
			}
		},
		validate() {
			var invalidFields = [];
			if(!this.hotelsFilterClient.destination)
				invalidFields.push(this.translation.destination);
			if(!this.hotelsFilterClient.checkin)
				invalidFields.push(this.translation.checkin);
			if(!this.hotelsFilterClient.checkout)
				invalidFields.push(this.translation.checkout);

			if(invalidFields.length > 0){
				this.$store.dispatch("showAlert", {
					message: this.translation.invalidFields + invalidFields.join(', '),
					code: 0,
					style: "warning"
				});
				return false;
			}

			this.hotelsFilter.checkin = moment(this.hotelsFilterClient.checkin).format('DD/MM/YYYY');
			this.hotelsFilter.checkout = moment(this.hotelsFilterClient.checkout).format('DD/MM/YYYY');
			this.hotelsFilter.hotelId = "";
			this.hotelsFilter.cityId = "";
			this.hotelsFilter.specialDestinationId = "";
			this.hotelsFilterClient.destination.type == DestinationType.HOTEL.name ? this.hotelsFilter.hotelId = this.hotelsFilterClient.destination.id :
				this.hotelsFilterClient.destination.type == DestinationType.CITY.name ? this.hotelsFilter.cityId = this.hotelsFilterClient.destination.id :
				this.hotelsFilter.specialDestinationId = this.hotelsFilterClient.destination.id;
			return true;
		},
		list() {
			this.loading = true;
			this.hotels = null;
			if(!this.validate()) return false;

			this.hotelService.list(this.hotelsFilter)
				.then((res) => {
					if (res.data.hotels.length > 0) {
						this.hotels = res.data.hotels;
						this.hotels.forEach(h => {
							h.minimumPrice = parseFloat(h.minimumPrice);
							h.maximumPrice = parseFloat(h.maximumPrice);
							h.roomTypes.forEach(r => {
								r.prices = sortBy(r.prices, [function(p) { return parseFloat(p.dailyPricePerRoom); }])
							})
							h.roomTypes = sortBy(h.roomTypes, [function(r) { return parseFloat(r.prices[0].dailyPricePerRoom); }]);
						});
						this.mainHotels = this.hotels;
						this.hotelsFilterClient.totalItems = res.data.hotels.length;
						this.calculateMinMaxFilter();
						this.setDistricts();
						this.filterHotels();
					} else
						this.$store.dispatch("showAlert", {
							message: this.translation.resultNotFound,
							code: 0,
							style: "warning"
						})

					this.loading = false;
				});
		},
		formatDate(date) {
			return moment(date).format('DD/MM/YYYY');
		},
		childrenChange(e) {
			if (e == 0)
				this.hotelsFilter.chdAges = [];
			else
				this.hotelsFilter.chdAges = Array(e);
		},
		getIcon(field) {
			if (field == this.hotelsFilterClient.orderBy.field) {
				if (this.hotelsFilterClient.orderBy.desc == true)
					return 'keyboard_arrow_down';
				else
					return 'keyboard_arrow_up';
			} else {
				return 'unfold_more';
			}
		},
		sortItems() {
			var field = this.hotelsFilterClient.orderBy.field == 'price' ? this.hotelsFilterClient.orderBy.desc ? 'maximumPrice' : 'minimumPrice' : this.hotelsFilterClient.orderBy.field;
			this.hotels = this.hotelsFilterClient.orderBy.desc ? sortBy(this.hotels, field).reverse() : sortBy(this.hotels, field);
		},
		calculateMinMaxFilter() {
			this.range.min = Number.MAX_VALUE;
			this.range.max = Number.MIN_VALUE;
			minBy(this.hotels, 'minimumPrice').roomTypes.forEach(r => {
				r.prices.forEach(p => parseFloat(p.dailyPricePerRoom) < this.range.min ? this.range.min = parseFloat(p.dailyPricePerRoom) : null)
			})
			maxBy(this.hotels, 'maximumPrice').roomTypes.forEach(r => {
				r.prices.forEach(p => parseFloat(p.dailyPricePerRoom) > this.range.max ? this.range.max = parseFloat(p.dailyPricePerRoom) : null)
			})
			this.hotelsFilterClient.min = this.range.min;
			this.hotelsFilterClient.max = this.range.max;
		},
		setDistricts() {
			this.districts = [...new Set(this.hotels.map(h => h.district).filter(h => h != null).sort())];
		},
		updateRangeValue(value, field) {
			this.hotelsFilterClient[field] = value;
			this.filterHotels();
		},
		filterHotels() {
			this.hotels = this.mainHotels;
			this.hotels = this.hotels.filter(h => h.starRating <= this.hotelsFilterClient.starRating);
			this.hotels = this.hotels.filter(h => h.name.toUpperCase().includes(this.hotelsFilterClient.name.toUpperCase()));
			this.hotels = this.hotels.filter(h => h.maximumPrice >= this.hotelsFilterClient.min);
			this.hotels = this.hotels.filter(h => h.minimumPrice <= this.hotelsFilterClient.max);
			if(this.hotelsFilterClient.selectedDistrict.length > 0) this.hotels = this.hotels.filter(h => this.hotelsFilterClient.selectedDistrict.includes(h.district));
			this.hotelsFilterClient.totalItems = this.hotels.length;
			this.sortItems();
			this.changePage();
		},
		clearFilter() {
			this.hotelsFilterClient = {...this.hotelsFilterClient, starRating: 5, name: ''};
			this.hotelsFilterClient.selectedDistrict = [];
			this.hotels = this.mainHotels;
			this.calculateMinMaxFilter();
			this.$refs.doubleRangeSlider.reset();
		},
		changePage(){
			var offsetStart = (this.hotelsFilterClient.currentPage - 1) * this.hotelsFilterClient.perPage;
      var offsetEnd = this.hotelsFilterClient.currentPage * this.hotelsFilterClient.perPage;
			this.hotels = this.hotels.slice(offsetStart, offsetEnd);
		},
		async toggleMore(id) {
			var moreAbouts = document.getElementsByClassName('expand') || [];
			var moreAbout = document.getElementById('more-about-'+id);
			if(moreAbout.classList.contains('expand')) {
				this.hotelInfo = {};
				moreAbout.classList.remove('expand');
			} else {
				await this.hotelService.getHotelInfo(id, this.$store.state.language.symbol)
				.then((hotelInfoRes) => {
					this.hotelInfo = {...hotelInfoRes.data.hotels[0], description: hotelInfoRes.data.hotels[0].translations.find(t => t.language.code == this.$store.state.language.lang).description};
					for(var i=0; i<moreAbouts.length; i++) {
						moreAbouts.item(i).classList.remove('expand');
					}
					moreAbout.classList.add('expand');
				});
			}
		},
		translateHotelDescription() {
			if(Object.keys(this.hotelInfo).length > 0)
				this.hotelInfo = {...this.hotelInfo, description: this.hotelInfo.translations.find(t => t.language.code == this.$store.state.language.lang).description};
		},
		openConfirmation(hotel, room, price) {
			var bookingInfo = {
				checkin: this.hotelsFilter.checkin,
				checkout: this.hotelsFilter.checkout,
				roomsQty: this.hotelsFilter.roomsQty,
				adultsQty: this.hotelsFilter.adultsQty,
				chdAges: this.hotelsFilter.chdAges,
				cancellationPolicyText: describeCancelationPolicy(price.cancellationPolicy, this.$store.state.language),
				hotel: hotel,
				roomType: room,
				price: price,
			}
			this.$refs[price.id+'confirmations'+room.id][0].open(bookingInfo);
		},
		showRowTooltip(priceId, roomTypeId){
			return !(this.$refs[priceId+'confirmations'+roomTypeId] != undefined && this.$refs[priceId+'confirmations'+roomTypeId][0] != undefined && this.$refs[priceId+'confirmations'+roomTypeId][0].isOpen); //
		}
	},
	watch: {
    'hotelsFilterClient.orderBy': {
      handler(newVal, oldVal) {
				if (newVal.field == oldVal.field)
					this.hotelsFilterClient.orderBy.desc = !this.hotelsFilterClient.orderBy.desc;

        this.hotelsFilterClient.currentPage = 1;
        this.filterHotels();
      }
    },
		'translation': {
			handler() {
				this.translateHotelDescription();
			}
		}
	}
}
</script>

<style scoped lang="scss">
.search-box {
	background-color: #e8e8e8;
	width: 85%;
	border-radius: 5px;
	margin: 1em auto;
	padding: 0.8em;
	box-shadow: 1px 1px 1px 0px #c3c3c3;
	position: relative;
}

.search-button {
	float: right;
	background-color: #163247;
}

.results-container {
	margin: 1em auto 10%;
	width: 85%;
}

.results-area {
	display: flex;
	justify-content:
	space-between;
}

.filter-box {
	width: 25%;
	padding: 1em;
	background-color: #e8e8e8;
	border: 1px solid #dbd8d1;
}

.filter-title {
	text-align: center;
}

.mobile-filter-button {
	display: inline;
  vertical-align: middle;
	float: none;
}

.result-box {
	width: 74%;
	display: flex;
	flex-direction: column;
	gap: 1em;
}

.hotel-info {
	width: 100%;
	border: 1px solid #dbd8d1;
	background-color: #e8e8e8;
	padding: 1em 2em;

	.hotel-info-header {
		width: 20%;
		float: left;

		img {
			max-width: 100%;
		}
	}

	.hotel-summary {
		float: right;
		width: 75%;

		.rating-star {
			color: #f9f6ef;
			background-color: #0f2c3e;
			border-radius: 4px;
			font-size: 1em;
			padding: 2px;
			margin: 1px;
		}
	}

	.hotel-info-price {
		width: 100%;
		float: left;
		margin: 5% 0px;
		line-height: 2.5em;

		.white-row {
			background-color: white;
		}
	}
}

.btn-book {
	background-color: #0f2b40 !important;
	color: white;
	width: 100%;

	&:hover {
		background-color: #0b1e2d !important;
	}
}

.btn-more-about {
	background-color: #e8e8e8;
	color: black;
	border: 1px solid #c3c3c3;
	float: right;
}

.more-about-box {
	overflow: hidden;
	width: 100%;
	height: 0px;
}

.expand {
	overflow: visible;
	height: auto;
}

.hotel-info-area {
	width: 100%;
	margin: 1em auto;
}

.hotel-description {
	width: 100%;
	margin: 2em auto;
	padding: 0px 3em;
	font-size: 12px;
	font-weight: bolder;
}

.facility {
	display: flex;
	gap: 3px;
	align-items: center;
}

.topics {
	display: flex;
	justify-content: space-between;
  width: 100%;
  padding-top: 1em;
}

.topic {
    width: 33.3%;
    background-color: #163247;
    border-right: 1px solid white;
    color: #ffffff;
    font-weight: normal;
		padding: 0.5em;
}

.pagination-box {
	display: flex;
	justify-content: space-between;
	margin: 1em auto;
}

.order-box {
	display: flex;
	width: 85%;
	height: 3em;
	margin: 1em auto;
	background: #163247;

	.title {
		background: #e8e8e8;
		width: 20%;
		height: 100%;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;

		.arrow {
			width: 0px;
			height: 0px;
			font-size: 0px;
			line-height: 0px;
			border-top: 20px solid transparent;
			border-bottom: 23px solid transparent;
			border-left: 20px solid #e8e8e8;
			position: absolute;
			left: 100%;
			top: 0%;
		}
	}

	.options {
		display: flex;
		justify-content: space-evenly;
		height: 100%;
		width: 75%;
		color: #ffffff;

		span {
			height: 100%;
			display: flex;
			align-items: center;
			cursor: pointer;
		}
	}
}

@media (max-width:576px) {
	.filter-fields {
		display: block;
    overflow: hidden;
		height: 0px;
	}

	.filter-fields.open {
		height: auto;
	}

	.filter-title {
		text-align: unset;
	}

	.mobile-filter-button {
		display: block;
		height: 100%;
		float: right;
		cursor: pointer;
	}
	.search-box {
		width: 90%;
		margin: 2% 5%;
	}
	.order-box {
		.title {
			display: none;
		}
		.options {
			width: 100%;
		}
	}

	.pagination-box {
		justify-content: center;
		gap: 10px;
    flex-direction: column;
    align-items: center;
	}

	.results-container {
		width: 95%;
	}

	.results-area {
		flex-direction: column;
		gap: 5px;
	}

	.filter-box {
		width: 100%;
	}

	.result-box {
		width: 100%;
	}
}
</style>
<style lang="scss">
.multiselect__option--group {
	background: #163247 !important;
	color: #ffffff !important;
}

.dropdown-menu.show {
    top: 36px !important;
    transform: none !important;
}

.tooltip .tooltip-inner{
  max-width: none !important;
}

@media (max-width:576px) {
	#checkoutFormGroup .dropdown-menu.show {
		right: 0px;
		left: auto !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/make-your-bookings/MakeYourBookings.vue